import { IconifiedList } from '@zillow/zrs-comet';
import { styled } from '@/styled-system/jsx';

import ConnectedModuleCard from '../ConnectedModuleCard';

export const StyledConnectedModuleCard = styled(ConnectedModuleCard, {
  base: {
    lg: { minHeight: '510px' },
  },
});

/**
 * There is an issue where text-overflow ellipsis does not work within flexbox
 * set direct
 * suggestion was to add min-width to the parent flext item of the text element
 * that wasn't the exact solution for this, but applying that to
 * the following classes worked.
 *
 * ref: https://www.phind.com/search?cache=450991ba-a52f-4287-8e18-24bbde838398
 */
export const StyledIconifiedList = styled(IconifiedList, {
  base: {
    "& [class^='IconifiedList__Items']": {
      minWidth: '0',
    },
    "& [class*='IconifiedList-ItemContent']": {
      minWidth: '0',
    },
  },
});
